import React, { useState, useEffect } from 'react';
import './App.css';
import ExpenseForm from './components/ExpenseForm';
import Alert from './components/Alert';
import ExpenseList from './components/ExpenseList'
import { v4 as uuidv4 } from 'uuid';


// const initialExpenses = [
//   {id:uuidv4(), charge:"rent", amount:1600},
//   {id:uuidv4(), charge:"car payment", amount:400},
//   {id:uuidv4(), charge:"credit card", amount:1200}
  
// ]

const initialExpenses = localStorage.getItem("expenses") 
? JSON.parse(localStorage.getItem("expenses"))
: [];


function App() {
  //************* The state below is for all the expenses */
const [expenses, setExpenses] = useState(initialExpenses);

//******* The state for single expense  */
const [charge, setCharge] = useState('');

//******* The state for single expense amount  */
const [amount, setAmount] = useState( ' ');

//********alert */
const [alert, setAlert] = useState({ show: false });

//********edit state */
const [edit, setEdit] = useState(false);

//*******edit time */
const [id, setId] = useState(0);

//******* functionalities below  */

//*** handleCharge */
const handleCharge = e => {
  setCharge(e.target.value)
};
//*** handleAmount */
const handleAmount = e => {
  setAmount(e.target.value)
};
//*** handleAlert */
const handleAlert = ({ type, text }) => {
  setAlert({ show: true, type, text });
  setTimeout(() => {
    setAlert({ show: false });
  }, 5000);
};

//*** handleSubmit */
const handleSubmit = e => {
  e.preventDefault();
  if (charge !== "" && amount > 0) {
    if (edit) {
      let tempExpenses = expenses.map(item => {
        return item.id === id? {...item, charge: charge, 
          amount: amount} : item;
      });
      setExpenses(tempExpenses);
      setEdit(false);
      handleAlert({ type: "success", text: "item edited"})

    } else {
    const singleExpense = {id: uuidv4(), charge, amount};
    setExpenses([...expenses, singleExpense]);
    handleAlert({type: "success", text: "item added"});
  }
    setCharge("");
    setAmount("");
  } else {
    //alert
    handleAlert({
      type: "danger",
    text: `Charge can't be an empty value and Amount needs to be bigger than zero`})
  }
};

//******* Clear expenses */
const clearItems = () => {
setExpenses([]);
handleAlert({ type: "danger", text: "All items deleted"})
};
//******* Delete input */
const handleDelete = id => {
  let selectedExpense = expenses.filter(item => item.id !== id);
  setExpenses(selectedExpense);
  handleAlert({ type: "danger", text: "item deleted"})
};

//******* Edit input */
const handleEdit = id => {
  let expense = expenses.find(item => item.id === id);
  let { charge, amount } = expense;
  setCharge(charge);
  setAmount(amount);
  setEdit(true);
  setId(id);
  
};

//******* Use Effect. It can be added anywhere */
useEffect(() => {
  localStorage.setItem("expenses", JSON.stringify(expenses));
}, [expenses]);

  return (
    <div>
      {alert.show && <Alert type={alert.type} text=
      {alert.text} />}
      <Alert />
      <h1>Budget Calculator</h1>
      <main className="App">

      <ExpenseForm  
      charge={charge}
      amount={amount}
      handleCharge={handleCharge}
      handleAmount={handleAmount}
      handleSubmit={handleSubmit}
      edit={edit}
      />

      <ExpenseList 
      expenses={expenses}
      handleDelete={handleDelete}
      handleEdit={handleEdit}
      clearItems={clearItems}
      />

      </main>
      <h1>
        total spending: {" "}
         <span className="total">
           ${" "}
          {expenses.reduce((acc, curr) => {
            return (acc += parseInt(curr.amount))
          }, 0)}
        </span>
      </h1>
    </div>
  );
}

export default App;
